import { useCallback, useState } from 'react';
import { MeetRemainingTimeDomainEvents } from '../domain/events';
import { publish } from '../../EventsBus/services/service';

export function useRemainingTime() {
	const [remainingModal, setRemainingModal] = useState(false);
	const [timerFinished, setTimerFinished] = useState(false);

	const onTimerFinished = useCallback(() => {
		setTimerFinished(true);
		publish(MeetRemainingTimeDomainEvents.timerFinished);
	}, []);

	const openRemainingModal = useCallback(() => {
		setRemainingModal(true);
		publish(MeetRemainingTimeDomainEvents.openedRemainingTimeModal);
	}, []);

	const closeRemainingModal = useCallback(() => {
		setRemainingModal(false);
		publish(MeetRemainingTimeDomainEvents.closedRemainingTimeModal);
	}, []);
    
	return {
		timerFinished,
		remainingModal,
		openRemainingModal,
		onTimerFinished,
		closeRemainingModal,
	};
}   